<template>
  <div class="Cards">
  
    <b-card  bg-variant="secondary" text-variant="dark" :header="lang.header_description" class="cardclass" :footer="lang.footer_Description" >
      <p class="card-text-param">
        <span class="infotext" v-show="!exists">{{lang.infotext_1}}</span>
        <ChartComponent v-if="((exists == true) && (type=='chart'))" :complete="complete"  :data="data" :action="action" :chartType="typeChart" :lang="lang.Chart"></ChartComponent>
        <MyTasksTableComponent  v-if="((exists == true) && (type=='table') && (name=='MyTasks'))" :lang="lang.Table"></MyTasksTableComponent>
        <EndOfPartsTableComponent  v-if="((exists == true) && (type=='table') && (name=='EndOfParts'))" :data="data" :action="action" :lang="lang.Table"></EndOfPartsTableComponent>
        <LibStatusesComponent v-if="((exists == true) && (type=='table') && (name=='LibStatuses'))" :data="data" :action="action" :lang="lang.Table"></LibStatusesComponent>
        <MyRequestsTableComponent  v-if="((exists == true) && (type=='table') && (name=='MyRequests'))" :lang="lang.Table"></MyRequestsTableComponent>
       
      </p>
    </b-card>

  </div>
</template>
<script>
  // import { mapGetters } from 'vuex'
  import ChartComponent from "@/components/shared/ChartComponent"
  import MyTasksTableComponent from "@/components/shared/MyTasksTableComponent"
  import EndOfPartsTableComponent from "@/components/shared/EndOfPartsTableComponent"
  import LibStatusesComponent from "@/components/shared/LibStatusesComponent"
  import MyRequestsTableComponent from "@/components/shared/MyRequestsTableComponent"

export default {
  name: "CardComponent",
  props:{
    type: String,
    name: String,
    lang: Object
  },
  components: {
    ChartComponent,
    MyTasksTableComponent,
    EndOfPartsTableComponent,
    LibStatusesComponent,
    MyRequestsTableComponent
  },
  data () {
      return {
        data: [],
        action: {
          actionId: "",
          name: ""
        },
        actions: [],
        exists: true,
        typeChart: "",
        complete: false
      }
  },
  created () {
    

    this.getActions();
    
    
    


  },
  computed: {
    // ...mapGetters({
      

    // }),
    isData(){
      return this.data.length != 0;
    }
  },
  updated() {
    
  },
  watch: {
    
  },
  methods: {
    getActions(){

      
      let vue = this;

      if (this.name == "MyTasks" || this.name == "ActiveParts" || this.name == "PendingParts" || this.name == "EndOfParts" || this.name == "RoHSParts"){
        this.$store.dispatch("pm_getActions")
        .then((result) =>{

          console.log(result)
          if (result.status == "OK"){
            vue.actions = result.data;
          
            vue.buildActions();
          }
          
        })
      }
      if (this.name == "ActiveLibraries" || this.name == "PendingLibraries"){
        vue.$store.dispatch("lm_getActions")
        .then((result) =>{

          console.log(result)
          if (result.status == "OK"){
            vue.actions = result.data;
            
            vue.buildActions();
          }
          
        })
      }
      if (this.name == "MyRequests"){
        vue.$store.dispatch("rm_getActions")
        .then((result) =>{

          console.log(result)
          if (result.status == "OK"){
            vue.actions = result.data;
            
            vue.buildActions();
          }
          
        })
      }

      
      

    },
    buildActions(){

      switch (this.name) {
      case "ActiveParts":
        
        this.action.name = "Active parts";
        this.typeChart = "pie";
        this.action.source = ["parts"];
        this.buildActiveParts();
        break;
      case "PendingParts":
        
        
        this.action.name = "Pending parts";
        this.typeChart = "pie";
        this.action.source = ["parts"];
        this.buildPendingParts();
        break;
      case "ActiveLibraries":
        
        this.action.name = "Active libraries";
        this.typeChart = "pie";
        this.action.source = ["libraries"];
        this.buildActiveLibraries();
        break;
      case "PendingLibraries":
        
        
        this.action.name = "Pending libraries";
        this.typeChart = "pie";
        this.action.source = ["libraries"];
        this.buildPendingLibraries();
        break;  
      case "RoHSParts":
        
        
        this.action.name = "RoHS compliant";
        this.typeChart = "stack";
        this.action.source = ["parts"];
        this.buildROHSParts();
          break; 
      case "LibStatuses":


        this.action.name = "Statuses of libraries";
        this.action.source = ["libraries"];
        this.buildLibStatuses();
        break;   
      case "MyTasks":
        
        
        this.action.name = "MyTasks";
        this.action.source = ["parts", "libraries"];
        this.buildMyTasks();
        break;  

       case "EndOfparts":
        
        
        this.action.name = "EndOfParts";
        this.action.source = ["parts"];
        this.buildEndOfParts();
          break;    
      case "MyRequests":
        
        
        this.action.name = "MyRequests";
        this.action.source = ["requests"];
        this.buildMyRequests();
        break;  
       
      default:
        break;
    }



      for (let i = 0, lei = this.actions.length; i < lei; i++){
        
        if (this.actions[i].name == this.action.name){

          this.action.actionId = this.actions[i].actionId;
          break;
        }
      }

      

    },
    buildActiveParts(){
      let vue = this;
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getActiveParts")
      .then((result) =>{

        console.log(result)
        if (result.status == "OK"){
          vue.data = result.data;
          vue.complete = true;
        }
        
      })

    },
    buildPendingParts(){
      let vue = this;
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPendingParts")
      .then((result) =>{

        console.log(result)
        if (result.status == "OK"){
          vue.data = result.data;
          vue.complete = true;
        }
      })

    },
    buildActiveLibraries(){
      let vue = this;
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getActiveLibraries")
      .then((result) =>{

        console.log(result)
        if (result.status == "OK"){
          vue.data = result.data;
          vue.complete = true;
        }
        
      })

    },
    buildPendingLibraries(){
      let vue = this;
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPendingLibraries")
      .then((result) =>{

        console.log(result)
        if (result.status == "OK"){
          vue.data = result.data;
          vue.complete = true;
        }
      })

    },
    buildROHSParts(){
      let vue = this;
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getROHSCompliant")
      .then((result) =>{

        console.log(result)
        if (result.status == "OK"){

          vue.data = result.data.data;
          vue.exists = result.data.exists;
          vue.complete = true;
        }
      })

    },
    buildLibStatuses() {
      let vue = this;
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibStatuses")
        .then((result) => {

          console.log(result)
          if (result.status == "OK") {
            vue.data = result.data;
          }
        })

    },
    buildMyTasks(){
      // let vue = this;
      // this.$store.dispatch(this.$store.getters.sectionPrefix + "_getMyTasks")
      // .then((result) =>{

      //   console.log(result)
      //   if (result.status == "OK"){
      //     vue.data = result.data;
      //   }
      // })

    },
    buildEndOfParts(){
      let vue = this;
      const obj = {
           days: 365
      }
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getEndOfParts", obj)
      .then((result) =>{

        console.log(result)
        if (result.status == "OK"){
          vue.data = result.data;
        }
      })

    },
    buildMyRequests(){
      
    },
  },
}

</script>
<style lang="scss">

  @import "@/../../../scss/_theme.scss";

  .Cards{

    .card{
      margin-right: 0px;
      margin-top: 10px;
      margin-bottom: 0px;
      margin-left: 10px;
      max-width: 460px;
      max-height: 350px;
      min-width: 460px;
      min-height: 350px;
      //border: 1px solid #999;
    }
    .card-text-param{
      margin-top: 10px;
      margin-bottom: 10px;

    }

    .card-header div{
      margin-left: 5px;
      margin-right: 5px;
      margin-top: 2px;
      font-weight: bold;

    }

    .card-footer div{
      margin-left: 5px;
      margin-right: 5px;
      margin-top: 2px;
    }
  }

  .TableComponent{
    margin-left: 5px;
    margin-right: 5px;
  }
  .infotext{
    margin-left: 20px;
  }
</style>





// WEBPACK FOOTER //
// src/components/shared/CardComponent.vue